import Vue from "vue";
import Vuex from "vuex";

import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";

import axios from "@/widgets/shared/utils/axios-instance";
import AxiosInterceptor from "@/widgets/shared/plugins/axios-interceptor";
import Constants from "@/widgets/shared/constants";

//namespaced modules
import days from "@/widgets/agenda/store/modules/days";
import paths from "@/widgets/agenda/store/modules/paths";
import places from "@/widgets/agenda/store/modules/places";
import components from "@/widgets/agenda/store/modules/components";
import agendas from "@/widgets/agenda/store/modules/agendas";
import sessions from "@/widgets/agenda/store/modules/sessions";
import schedule from "@/widgets/agenda/store/modules/schedule";
import meetings from "@/widgets/agenda/store/modules/meetings";
import speakers from "@/widgets/agenda/store/modules/speakers";
import agendaSessionTickets from "@/widgets/agenda/store/modules/agenda-session-tickets";
import agendaSessionAttendees from "@/widgets/agenda/store/modules/agenda-session-attendees";
import agendaSessionRatings from "@/widgets/agenda/store/modules/agenda-session-ratings";
import errorModal from "@/widgets/shared/store/modules/error-modal";
import modals from "@/widgets/agenda/store/modules/modals";
import lpNotifications from "@/widgets/agenda/store/modules/lp-notifications";
import widgetView from '@/widgets/shared/store/modules/widget-view';

Vue.use(Vuex);

export function state() {
  return {
    lpMode: false,
    token: null,
    accessCode: null,
    slug: null,
    eventId: null,
    constantComponentId: null,
    componentIdsWithRatingAlwaysEnabled: null,
    timezone: null,
    settings: null,
    eventColors: null,
    currentTime: null,
    requestRefreshToken: false,
    locale: null,
    theme: Constants.WIDGET_THEME_TYPES.DEFAULT,
    hideSessionTime: false,
    showLiveIndicator: false,
    hideLiveStreamButtons: false,
    sessionRatings: null,
    customSponsor: null,
    speakersCountOnPreview: 3,
    highlightedSessionIds: [],
    sessionTimeWithDate: false,
    preselectedPathIds: [],
    preselectedPlaceIds: [],
    preselectedDayId: null,
    questionsDisabled: null,
    appId: null,
  };
}

// eslint-disable-next-line prettier/prettier
export const plugins = [
  AxiosInterceptor.install(axios),
];

export const modules = {
  days,
  paths,
  places,
  components,
  agendas,
  sessions,
  schedule,
  meetings,
  speakers,
  agendaSessionTickets,
  agendaSessionAttendees,
  agendaSessionRatings,
  lpNotifications,
  errorModal,
  modals,
  widgetView,
};

export function createStore() {
  return new Vuex.Store({
    plugins,
    state,
    getters,
    mutations,
    actions,
    modules,
  });
}
